"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ArrowIcon_1 = __importDefault(require("@centered/components/dist/icons/ArrowIcon"));
var react_1 = __importDefault(require("react"));
function AuthSubmitButton(_a) {
    var children = _a.children, disabled = _a.disabled, props = __rest(_a, ["children", "disabled"]);
    return (react_1.default.createElement("div", __assign({}, props, { className: "cursor-pointer bg-gradient-to-r from-v5-red to-v5-pink flex-shrink-0 text-white text-base tracking-wide px-4 py-2 rounded-full font-semibold flex items-center gap-2 transition-colors arrow-button ".concat(disabled ? 'pointer-events-none opacity-50' : '') }),
        react_1.default.createElement("input", { type: "submit", className: "sr-only", disabled: disabled }),
        children,
        react_1.default.createElement("div", { className: "arrow-icon" },
            react_1.default.createElement(ArrowIcon_1.default, { direction: "right" }))));
}
exports.default = AuthSubmitButton;
